/**
 * Migas de pan. **Componente propio: el design system no lo tiene.**
 *
 * Sigue la convención del DS —clases `mpfn-*` planas, variantes por `data-*`,
 * `mpfn-control` para el contrato de foco— para que proponerlo como
 * contribución sea copiar el archivo. Ver SISTEMA_DISENO.md §3.2.
 *
 * Se usa en los niveles 2 y 3: `Bloque setiembre 2026 / PÉREZ RAMOS, Juan /
 * 2. Formación`. El último elemento NO es un enlace y lleva `aria-current`.
 */
import { Fragment } from 'react'
import { ChevronRight } from 'lucide-react'
import { Enlace } from '../navegacion/Enlace.js'
import type { Vista } from '../navegacion/rutas.js'

export interface Miga {
  etiqueta: string
  vista?: Vista
  parametros?: Readonly<Record<string, string>>
}

export function Breadcrumb({ migas }: { migas: readonly Miga[] }) {
  if (migas.length === 0) return null

  return (
    <nav aria-label="Ruta de navegación" className="mpfn-breadcrumb">
      <ol className="mpfn-breadcrumb__lista">
        {migas.map((miga, indice) => {
          const esUltima = indice === migas.length - 1
          return (
            <Fragment key={`${miga.etiqueta}-${String(indice)}`}>
              <li className="mpfn-breadcrumb__item">
                {esUltima || !miga.vista ? (
                  <span
                    className="mpfn-breadcrumb__actual"
                    {...(esUltima ? { 'aria-current': 'page' as const } : {})}
                  >
                    {miga.etiqueta}
                  </span>
                ) : (
                  <Enlace
                    vista={miga.vista}
                    {...(miga.parametros ? { parametros: miga.parametros } : {})}
                    className="mpfn-breadcrumb__enlace mpfn-control"
                  >
                    {miga.etiqueta}
                  </Enlace>
                )}
              </li>
              {!esUltima && (
                <li aria-hidden="true" className="mpfn-breadcrumb__separador">
                  <ChevronRight size={14} />
                </li>
              )}
            </Fragment>
          )
        })}
      </ol>
    </nav>
  )
}
